import type {
  Items,
  Link,
} from '@solfacil/girassol/dist/types/components/sidebars/sidebar/types';
import type { NuxtLinkResolved } from '@solfacil/girassol/dist/types/types';
import type { ConcreteComponent } from 'vue';

import type { MenuLink, ModulesLink } from '~/types';

import MyProposals from '~icons/girassol/collections-bookmark';
import MyOrders from '~icons/girassol/library-books';
import SellIcon from '~icons/girassol/sell';

export function useMenus(linkResolver: string | ConcreteComponent) {
  const defaultMenusDesktop: MenuLink[] = [
    {
      id: 'assemble-kit',
      label: 'Monte seu kit',
      href: '/',
      hrefProp: 'to',
      linkTag: linkResolver as NuxtLinkResolved,
    },
    {
      label: 'Produtos avulsos',
      href: '/spare-products',
      hrefProp: 'to',
      linkTag: linkResolver as NuxtLinkResolved,
    },
    {
      label: 'Ofertas',
      href: '/closed-kits',
      hrefProp: 'to',
      linkTag: linkResolver as NuxtLinkResolved,
      icon: '/icons/sell.svg',
    },
  ];

  const wholesalerMenusDesktop: MenuLink[] = [
    {
      id: 'assemble-kit',
      label: 'Monte seu kit',
      href: '/',
      hrefProp: 'to',
      linkTag: linkResolver as NuxtLinkResolved,
    },
    {
      label: 'Produtos avulsos',
      href: '/spare-products',
      hrefProp: 'to',
      linkTag: linkResolver as NuxtLinkResolved,
    },
  ];

  const modulesDesktop: ModulesLink[] = [
    {
      label: 'Meus pedidos',
      icon: '/icons/library-books.svg',
      href: '/orders',
    },
    {
      label: 'Meus orçamentos',
      icon: '/icons/collections-bookmark.svg',
      href: '/proposals',
    },
  ];

  const route = useRoute();

  const wholesalerMenusMobile = computed<Items[]>(() => [
    {
      name: 'Produtos avulsos',
      isActive: route.name === 'spare-products',
      action: () => {
        navigateTo({ name: 'spare-products' });
      },
    },
    {
      name: 'Monte seu kit',
      isActive: route.name === 'index',
      action: () => {
        navigateTo({ name: 'index' });
      },
    },
  ]);

  const menusMobile = computed<Items[]>(() => [
    {
      name: 'Monte seu kit',
      isActive: route.name === 'index',
      action: () => {
        navigateTo({ name: 'index' });
      },
    },
    {
      name: 'Produtos avulsos',
      isActive: route.name === 'spare-products',
      action: () => {
        navigateTo({ name: 'spare-products' });
      },
      tagName: 'Novidade!',
      tagType: 'secondary',
    },
    {
      name: 'Ofertas',
      isActive: route.name === 'closed-kits',
      action: () => {
        navigateTo({ name: 'closed-kits' });
      },
      icon: SellIcon,
      iconColor: 'primary',
    },
  ]);

  const modulesMobile = [
    {
      icon: MyOrders,
      name: 'Meus Pedidos',
      href: '/orders',
      hrefProp: 'href',
      linkTag: 'a',
    },
    {
      icon: MyProposals,
      name: 'Meus Orçamentos',
      href: '/proposals',
      hrefProp: 'href',
      linkTag: 'a',
    },
  ] as Link[];

  return {
    defaultMenusDesktop,
    wholesalerMenusDesktop,
    modulesDesktop,
    menusMobile,
    wholesalerMenusMobile,
    modulesMobile,
  };
}
